import { render, staticRenderFns } from "./ProductStockFormRefactor.vue?vue&type=template&id=5effb9da&"
import script from "./ProductStockFormRefactor.vue?vue&type=script&lang=js&"
export * from "./ProductStockFormRefactor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports